"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_paper_1 = require("react-native-paper");
const styles_1 = __importDefault(require("../../styles/styles"));
const Toast = ({ text, visible, onDismiss }) => {
    return (react_1.default.createElement(react_native_paper_1.Snackbar, { wrapperStyle: [{ top: 0, position: 'absolute' }, styles_1.default.alignCenterCenter], elevation: 5, style: styles_1.default.blueBackground, onDismiss: onDismiss, onIconPress: onDismiss, visible: visible },
        react_1.default.createElement(react_native_paper_1.Text, { style: styles_1.default.textColorWhite }, `Copied ${text} to clipboard`)));
};
exports.default = Toast;
